import { z } from 'zod';

export const savedViewScopeSchema = z.enum([
  'transactions',
  'splits',
  'subscriptions',
  'reports',
]);
export type SavedViewScope = z.infer<typeof savedViewScopeSchema>;

export const createSavedViewSchema = z.object({
  name: z.string().min(1).max(120),
  scope: savedViewScopeSchema,
  filter: z.record(z.string(), z.unknown()).default({}),
  sortOrder: z.number().int().optional(),
});
export type CreateSavedViewInput = z.infer<typeof createSavedViewSchema>;

export const updateSavedViewSchema = createSavedViewSchema.partial();
export type UpdateSavedViewInput = z.infer<typeof updateSavedViewSchema>;

export const listSavedViewsQuerySchema = z.object({
  scope: savedViewScopeSchema.optional(),
});
export type ListSavedViewsQuery = z.infer<typeof listSavedViewsQuerySchema>;
